import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Shield } from 'lucide-react';
import { Button } from './Button';
export function PricingCTA() {
  return <section id="pricing" className="py-20 px-6 md:px-12 lg:px-24 bg-navy text-cream" data-id="element-137">
      <div className="max-w-4xl mx-auto" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white text-navy rounded-3xl p-8 md:p-12 shadow-2xl text-center" data-id="element-139">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 font-playfair" data-id="element-140">
            Asegura tu tranquilidad hoy
          </h2>
          <p className="text-xl text-navy-light mb-8" data-id="element-141">
            Obtén el paquete completo "Legado Digital Seguro" y organiza tu vida
            digital esta misma tarde.
          </p>

          <div className="mb-8" data-id="element-142">
            <div className="flex items-center justify-center gap-4 mb-1" data-id="element-143">
              <span className="text-3xl text-navy-light/50 line-through font-medium" data-id="element-144">
                $19 USD
              </span>
              <span className="bg-red-600 text-white text-sm font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-145">
                -66% Descuento
              </span>
            </div>
            <span className="text-6xl font-bold text-navy" data-id="element-146">$6.39</span>
            <span className="text-2xl text-navy-light font-medium" data-id="element-147"> USD</span>
            <p className="text-sm text-navy-light mt-2 uppercase tracking-wide font-bold" data-id="element-148">
              Pago único • Acceso de por vida
            </p>
          </div>

          <div className="bg-cream p-6 rounded-2xl text-left mb-8 max-w-2xl mx-auto" data-id="element-149">
            <h3 className="font-bold text-xl mb-4" data-id="element-150">
              Recibirás inmediatamente:
            </h3>
            <ul className="space-y-4" data-id="element-151">
              {['Inventario Maestro de Activos Digitales', 'Plantilla de Instrucciones de Emergencia', 'Organizador de Contraseñas Analógico', 'Registro de Suscripciones', 'Guía Visual: Configuración de Contacto Legado', 'BONUS: Checklist de Privacidad Post-mortem'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-152">
                  <CheckCircle className="w-6 h-6 text-gold shrink-0 mt-0.5" data-id="element-153" />
                  <span className="text-lg font-medium" data-id="element-154">{item}</span>
                </li>)}
            </ul>
          </div>

          <Button fullWidth className="max-w-xl mx-auto mb-6" href="https://beautifulhealthstyle.com/cart/51641104367832:1" data-id="element-155">
            Empieza Mi Legado Digital <span className="ml-2" data-id="element-156">→</span>
          </Button>

          <div className="flex items-center justify-center gap-2 text-navy-light font-medium" data-id="element-157">
            <Shield className="w-5 h-5 text-gold" data-id="element-158" />
            <span data-id="element-159">Entrega digital inmediata a tu correo electrónico.</span>
          </div>
        </motion.div>
      </div>
    </section>;
}